// src/lib/queries.js

export const landingPageQuery = `
  *[_type == "landingPage"][0]{
    heroImage{
      asset->{url}
    },
    heroImageMobile{
      asset->{url}
    },
    logoImage{
      asset->{url}
    },
    useVideo,
    heroVideoUrl,
    destinationPath
  }
`;

export const collectionsQuery = /* groq */ `
*[
  _type == "collection"
  && defined(slug.current)
] | order(coalesce(order, 999999) asc){
  _id,
  title,
  slug,
  order,
  // keep crop/hotspot by spreading the image object
  collectionImage{
    ...,
    asset->{
      _id,
      url,
      metadata{
        lqip,
        dimensions{
          width,
          height,
          aspectRatio
        }
      }
    }
  }
}
`;

export const menuItemsQuery = `
  *[_type == "menuItem"] | order(order asc) {
    _id,
    title,
    slug,
    "imageUrl": image.asset->url
  }
`;

export const lookbookQuery = `
  *[_type == "lookbookItem"] | order(order asc) {
    "url": image.asset->url
  }
`;

export const galleryCampaignsQuery = `
  *[_type == "galleryCampaign"] | order(order asc) {
    _id,
    title,
    "slug": slug.current,
    description,
    photographer,
    stylist,
    creativeDirector,
    creativeProducer,
    videographer,
    gaffer,
    lighting,
    hair,
    mua,
    models,
    "imgSrc": imgSrc.asset->url,
    "images": images[].asset->url,
    videoUrl
  }
`;

export const galleryCampaignBySlugQuery = (slug) => `
  *[_type == "galleryCampaign" && slug.current == "${slug}"][0] {
    title,
    description,
    photographer,
    stylist,
    videographer,
    gaffer,
    lighting,
    hair,
    mua,
    creativeDirector,
    creativeProducer,
    models,
    "images": images[].asset->url,
    "imgSrc": imgSrc.asset->url,
    videoUrl
  }
`;

export const aboutQuery = `
  *[_type == "aboutPage"][0]{
    seoTitle,
    metaDescription,
    headline,
    body,
    "imageUrl": image.asset->url,
    imageAlt,
    imageCaption
  }
`;

export const announcementQuery = `
*[_type == "announcement"][0]{
  enabled,
  message,
  speedMs,
  height,
  bgColor,
  textColor,
  startDate,
  endDate
}
`;